import { render, staticRenderFns } from "./create-resources.component.html?vue&type=template&id=539d9476&scoped=true&"
import script from "./create-resources.component.ts?vue&type=script&lang=ts&"
export * from "./create-resources.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-resources.component.scss?vue&type=style&index=0&id=539d9476&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d9476",
  null
  
)

export default component.exports